module.exports = __webpack_public_path__ + "static/media/technologies.7dd15345.png";